import * as React from 'react';
import HeaderText from './HeaderText';

const TextLogo = () => <HeaderText>Agora</HeaderText>

export default TextLogo;